(function () {

    'use strict';

    const {BehaviorSubject} = require("rxjs");

    class RecoveryBalanceCtrl {
        constructor(genericStatesService, system, $translate) {
            this.genericStatesService = genericStatesService;
            this.system = system;
            this.translate = $translate;
            this.dateFormat = system['date_format'].js;

            this.currentState = genericStatesService.getCurrentState("customer_recovery");

            this.showFilter = false;
            this.isChart = false;
            this.headers = {
                _id: {
                    type: "number",
                    caption: this.translate.instant('unique_id')
                },
                number: {
                    type: "string",
                    caption: this.translate.instant("invoice_number")
                },
                m_15: {
                    type: "number",
                    caption: this.translate.instant('m_15')
                },
                m_30: {
                    type: "number",
                    caption: this.translate.instant('m_30')
                },
                m_60: {
                    type: "number",
                    caption: this.translate.instant('m_60')
                },
                m_120: {
                    type: "number",
                    caption: this.translate.instant('m_120')
                }
            };
            this.$dataSource = new BehaviorSubject({
                slice: {},
                data: [],
                headers: {},
                onlyData: false
            });
        }

        static get $inject() {
            return ["genericStatesService", "system", "$translate"];
        }

        $onInit() {
            this.getData();
        }


        getSlice() {
            return {
                "expands": {
                    "expandAll": true,
                    "rows": [
                        {"tuple": []}
                    ]
                },
                "drills": {
                    "drillAll": false
                },
                "rows": [
                    {
                        "uniqueName": "number",
                    }

                ],
                "columns": [
                    {
                        "uniqueName": "Measures"
                    }
                ],
                "measures": [
                    {
                        "uniqueName": "m_15",
                        "individual": true,
                        "format": "currency",
                        "formula": "sum(\"m_15\")",
                    },
                    {
                        "uniqueName": "m_30",
                        "individual": true,
                        "format": "currency",
                        "formula": "sum(\"m_30\")",
                    },
                    {
                        "uniqueName": "m_60",
                        "individual": true,
                        "format": "currency",
                        "formula": "sum(\"m_60\")",
                    },
                    {
                        "uniqueName": "m_120",
                        "individual": true,
                        "format": "currency",
                        "formula": "sum(\"m_120\")",
                    }
                ],
            };
        }

        getData(onlyData = false) {
            this.promise = this.genericStatesService.getRecoveries()
                .then(data => {
                    if (onlyData) {
                        this.$dataSource.next({
                            onlyData: true,
                            data: data
                        });
                    } else {
                        this.$dataSource.next({
                            slice: this.getSlice(),
                            data: data,
                            headers: this.headers
                        });
                    }
                });
        }

        handleFileName() {
            return `${this.translate.instant('customer_recovery')}`;
        }

        onComplete(instance) {
        }
    }

    module.exports = RecoveryBalanceCtrl;
})();